module.exports = __webpack_public_path__ + "img/Tessellate18.ea53df6d.jpg";